import { render } from "./TaskDialog.vue?vue&type=template&id=34e8e1f4&scoped=true"
import script from "./TaskDialog.vue?vue&type=script&lang=js"
export * from "./TaskDialog.vue?vue&type=script&lang=js"

import "./TaskDialog.vue?vue&type=style&index=0&id=34e8e1f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e8e1f4"]])

export default __exports__